<section class="panel p-4">
  <h2 class="h5 mb-3">Cadastro de departamentos</h2>
  <form class="row g-3" (ngSubmit)="salvarDepartamento()">
    <div class="col-md-5">
      <label class="form-label">Empregador</label>
      <select
        class="form-select"
        name="departamentoEmpregador"
        [ngModel]="empregadorSelecionado"
        (ngModelChange)="selecionarEmpregador($event)"
        required>
        <option value="">Selecione</option>
        <option *ngFor="let item of empregadores" [value]="item.id">{{ item.razaoSocial }}</option>
      </select>
    </div>

    <div class="col-md-4">
      <label class="form-label">Departamento existente</label>
      <select
        class="form-select"
        name="departamentoExistente"
        [ngModel]="departamentoSelecionado"
        (ngModelChange)="selecionarDepartamento($event)">
        <option value="">Novo departamento</option>
        <option *ngFor="let item of departamentosCadastro" [value]="item.id">{{ rotuloDepartamento(item) }}</option>
      </select>
    </div>

    <div class="col-md-3 d-flex align-items-end">
      <button class="btn btn-outline-primary w-100" type="button" (click)="atualizarLista()">Atualizar</button>
    </div>

    <div class="col-md-8">
      <label class="form-label">Nome</label>
      <input class="form-control" name="departamentoNome" [(ngModel)]="departamento.nome" required>
    </div>

    <div class="col-md-4 d-flex align-items-end">
      <div class="form-check">
        <input class="form-check-input" type="checkbox" name="departamentoAtivo" [(ngModel)]="departamento.ativo">
        <label class="form-check-label">Ativo</label>
      </div>
    </div>

    <div class="col-12">
      <app-rodape-crud
        [exibirExcluir]="true"
        [excluirDesabilitado]="!departamento.id"
        (excluir)="excluirDepartamento()"
        (limpar)="limparDepartamento()"
        (salvar)="salvarDepartamento()">
      </app-rodape-crud>
    </div>
  </form>
</section>
